module.exports = __webpack_public_path__ + "img/anhngangvimc.cc3e4612.png";